export const ALLOWED_MEETING_DURATION_MINUTES = [15, 30, 60, 120];

export const BOOKING_DURATION_DISPLAY_LABELS = {
    15: '15 minutes',
    30: '30 minutes',
    60: '1 hour',
    120: '2 hours'
};

export const formatBookingDurationDropdownLabel = (rawMinutes) => {
    const m = normalizeBookingDurationMinutes(rawMinutes);
    return BOOKING_DURATION_DISPLAY_LABELS[m] || `${m} minutes`;
};

export const normalizeBookingDurationMinutes = (raw) => {
    const n = parseInt(raw, 10);
    if (!Number.isFinite(n) || n < 1) {
        return 30;
    }
    if (ALLOWED_MEETING_DURATION_MINUTES.includes(n)) {
        return n;
    }
    return ALLOWED_MEETING_DURATION_MINUTES.reduce((best, d) =>
        Math.abs(d - n) < Math.abs(best - n) ? d : best
    );
};

export const minutesToScheduleDurationValue = (totalMinutes) => {
    const norm = normalizeBookingDurationMinutes(totalMinutes);
    const h = Math.floor(norm / 60);
    const m = norm % 60;
    return `${h}:${String(m).padStart(2, '0')}`;
};

const SCHEDULE_DURATION_VALUES = ['0:15', '0:30', '1:00', '2:00'];

export const normalizeScheduleDurationValueString = (val) => {
    if (!val) {
        return '1:00';
    }
    if (SCHEDULE_DURATION_VALUES.includes(val)) {
        return val;
    }
    const p = String(val).split(':');
    const h = parseInt(p[0], 10) || 0;
    const m = parseInt(p[1], 10) || 0;
    return minutesToScheduleDurationValue(h * 60 + m);
};
